import React from 'react';

interface Props {
  children: React.ReactNode;
}

const FooterRow: React.FC<Props> = (props) => {
  const { children } = props;
  return (
    <div className="Footer__row">
      {children}
    </div>
  );
};

export default FooterRow;
